import React from "react";
import {MainCP}  from "../../Components/preferencia-presidencial/MainCP"

const ViewPreferenciaPresidencial: React.FC = () => <MainCP/>

export default ViewPreferenciaPresidencial;